import { useLoader } from "@/hooks/LoaderProvider";
import { useNavigate } from "react-router-dom";
import Button from "@/components/common/Button";

const Subscription = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();

  const handleProceed = () => {
    showLoader();
    setTimeout(() => {
      hideLoader();
      navigate("/payment-success");
    }, 2000);
  };

  return (
    <div className="flex flex-col min-h-screen px-4 w-full m-auto items-center justify-center max-w-[800px] mx-auto">
      <div>
        <h1 className="mb-2 text-center heading-large-x text-primary">
          Proceeed to Payment Gateway
        </h1>
        <p className="mb-6 text-center text-regular text-darkGrey">
          This UI is going to be payment processor&apos;s UI to collect the
          payment and the user returns back to the next page. Click on the
          &apos;CONTINUE&apos; Button to show the next page..
        </p>
      </div>

      <div className="w-full">
        <Button
          text="Continue"
          onClick={handleProceed}
          color="primary"
          customBgColor="primary"
          customTextColor="white"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default Subscription;
